<template>
  <UIInputFile
    v-model="modelValue"
    v-model:filename="filename"
    :data-refid="dataRefid"
    :label
    placeholder="Upload a file"
    :disabled
    :error
    :silent
    :size
    @ready="onReady"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref, watch } from 'vue'

import { DocumentClass } from '..'
import { InputSize } from '@types'

import { DOCUMENT_FIELD } from '../utils/const'

import { UIInputFile } from '@ui/fields'

type Props = {
  instance: DocumentClass
  disabled?: boolean
  label?: string
  focusOnLoad?: boolean
  dataRefid?: string
  size?: InputSize
}

const props = defineProps<Props>()

const modelValue = props.instance.field<FormData>(DOCUMENT_FIELD.FILE)

const filename = props.instance.field<string>(DOCUMENT_FIELD.FILENAME)

const isSavedDocument = inject('isSavedDocument', ref(false))

const error = computed(() => props.instance.errors.filename)
const silent = computed(() => !isSavedDocument.value)

const onReady = (el: HTMLInputElement) => {
  if (!props.focusOnLoad) return
  el.focus()
}

watch(filename, value => {
  if (props.instance.field<string>(DOCUMENT_FIELD.NAME).value) return
  props.instance.field<string>(DOCUMENT_FIELD.NAME).value = value
})
</script>
